import React, { useState, useEffect, useMemo } from "react"
import { withRouter } from "react-router-dom"
import PropTypes from "prop-types"
import API from "../../api"
import {
  Button,
  Col,
  Form,
  Input,
  Label,
  Row,
  Card,
  CardBody,
  Container,
  Spinner,
} from "reactstrap"
// Toastify
import { ToastContainer, toast } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"
import { Slide } from "react-toastify"
import { withTranslation } from "react-i18next"
import { AvForm, AvField } from "availity-reactstrap-validation"

const EditGrade = props => {
  const [grade, setGrade] = useState("")
  const [gradeArabe, setGradeArabe] = useState("")
  const [nbrCours, setNbrCours] = useState("")
  const [nbrTD, setNbrTD] = useState("")
  const [nbrTP, setNbrTP] = useState("")
  const [autre, setAutre] = useState("")
  const [priorite, setPriorite] = useState("")
  const [loading, setLoading] = useState(false)
  var userAuthScolarite = JSON.parse(localStorage.getItem("userAuthScolarite"))
  var annee_id = userAuthScolarite.user.annee_id
  var user_id = userAuthScolarite.user.id
  useEffect(async () => {
    var url = window.location.href
    var array = url.split("=")
    var id = array[1]
    const res = await API.post("grade/get_by_id", { id }).then(res => {
      setGrade(res.data.Grade.name_fr)
      setGradeArabe(res.data.Grade.name_ar)
      setNbrCours(res.data.Grade.nb_cours)
      setNbrTD(res.data.Grade.nb_td)
      setNbrTP(res.data.Grade.nb_tp)
      setAutre(res.data.Grade.autre)
      setPriorite(res.data.Grade.priorite)
      setLoading(true)
    })
  }, [])

  const edit = async () => {
    var url = window.location.href
    var array = url.split("=")
    var id = array[1]
    if (grade !== "") {
      const res = await API.post("grade/update", {
        id: id,
        name_fr: grade,
        name_ar: gradeArabe,
        nb_cours: nbrCours,
        nb_td: nbrTD,
        nb_tp: nbrTP,
        autre: autre,
        priorite: priorite,
        annee_id,
        user_id
      }).then(res => {
        if(res.data.status === 500 ){
          toast.error("⛔ "+res.data.msg, {
            containerId: "A",
          })
        }else{
          props.history.push("/Grade")
        }
      })
    } else {
      toast.error("⛔ Grade obligatoire", {
        containerId: "A",
      })
    }
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Row>
            <Card>
              <CardBody>
                {loading ? (
                  <AvForm>
                    <Form>
                      <Row>
                        <Col lg="6">
                          <div className="mb-3">
                            <Label for="basicpill-firstname-input1">
                              {props.t("Grade")} :
                            </Label>
                            <Input
                              lg="3"
                              className="form-control glyphicon glyphicon-star"
                              placeholder={props.t("Grade")}
                              type="text"
                              value={grade}
                              onChange={e => setGrade(e.target.value)}
                            />
                          </div>
                        </Col>
                        <Col lg="6">
                          <div className="mb-3">
                            <Label for="basicpill-firstname-input1">
                              {props.t("Grade Arabe")} :
                            </Label>
                            <Input
                              lg="3"
                              className="form-control glyphicon glyphicon-star"
                              placeholder={props.t("Grade Arabe")}
                              type="text"
                              value={gradeArabe}
                              onChange={e => setGradeArabe(e.target.value)}
                            />
                          </div>
                        </Col>

                      </Row>
                      <Row>
                        <Col lg="6">
                          <div className="mb-3">
                            <Label for="basicpill-firstname-input1">
                              {"Priorité pour la génération de l’emploi"} :
                            </Label>
                            <Input
                              lg="3"
                              type="number"
                              className="form-control"
                              placeholder="Priorité pour la génération de l’emploi"
                              value={priorite}
                              onChange={e => setPriorite(e.target.value)}
                            />
                          </div>
                        </Col>
                        <Col lg="6">
                          <div className="mb-3">
                            <Label for="basicpill-firstname-input1">
                              Nombre heure cours :
                            </Label>
                            <Input
                              lg="3"
                              type="number"
                              className="form-control"
                              placeholder="Nbr heure cours"
                              value={nbrCours}
                              onChange={e => setNbrCours(e.target.value)}
                            />
                          </div>
                        </Col>


                      </Row>
                      <Row>
                        <Col lg="6">
                          <div className="mb-3">
                            <Label for="basicpill-firstname-input1">
                              Nombre heure TD :
                            </Label>
                            <Input
                              lg="3"
                              type="number"
                              className="form-control"
                              placeholder="Nbr heure TD"
                              value={nbrTD}
                              onChange={e => setNbrTD(e.target.value)}
                            />
                          </div>
                        </Col>
                        <Col lg="6">
                          <div className="mb-3">
                            <Label for="basicpill-firstname-input1">
                              Nombre heure TP :
                            </Label>
                            <Input
                              lg="3"
                              type="text"
                              className="form-control"
                              placeholder="Nbr heure TP"
                              value={nbrTP}
                              onChange={e => setNbrTP(e.target.value)}
                            />
                          </div>
                        </Col>

                      </Row>
                      <Row>
                        <Col lg="6">
                          <div className="mb-3">
                            <Label for="basicpill-firstname-input1">
                              Nombre heure CI :
                            </Label>
                            <Input
                              lg="3"
                              type="text"
                              className="form-control"
                              placeholder="Nbr heure autre"
                              value={autre}
                              onChange={e => setAutre(e.target.value)}
                            />
                          </div>
                        </Col>
                      </Row>
                    </Form>
                    <div style={{ display: "flex", justifyContent: "center" }}>
                      {" "}
                      <Col lg="6">
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "flex-end",
                          }}
                          className="text-center mt-4"
                        >
                          <Button
                            type="button"
                            color="warning"
                            className="btn btn-warning  mb-2 me-2"
                            onClick={() => props.history.push("/Grade")}
                          >
                            {props.t("Annuler")}
                          </Button>
                        </div>
                      </Col>
                      <Col lg="6">
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "flex-start",
                          }}
                          className="text-center mt-4"
                        >
                          <button
                            type="button"
                            className="btn btn-primary "
                            onClick={edit}
                          >
                            {props.t("Confirmer")}
                          </button>
                        </div>
                      </Col>
                    </div>
                  </AvForm>
                ) : (
                  <div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                      }}
                    >
                      {" "}
                      <Spinner type="grow" className="ms-6" color="primary" />
                    </div>
                    <h4
                      style={{ textAlign: "center", marginTop: "2%" }}
                      className="ms-6"
                    >
                      {" "}
                      {"Chargement"} ...{" "}
                    </h4>
                  </div>
                )}
              </CardBody>
            </Card>
          </Row>
          <ToastContainer
            transition={Slide}
            enableMultiContainer
            containerId={"A"}
            position={toast.POSITION.TOP_RIGHT}
            autoClose={2500}
          />
        </Container>
      </div>
    </React.Fragment>
  )
}
export default withRouter(withTranslation()(EditGrade))
EditGrade.propTypes = {
  history: PropTypes.object,
  t: PropTypes.any,
}
